"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabHeader = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var tab_header_1 = require("../styled/tab-header");
var tabs_1 = require("../tabs");
var TabHeader = function (_a) {
    var children = _a.children;
    var isInverse = (0, react_1.useContext)(tabs_1.TabsContext).isInverse;
    return react_1.default.createElement(tab_header_1.TabHeader, { isInverse: isInverse }, children);
};
exports.TabHeader = TabHeader;
//# sourceMappingURL=tab-header.js.map